import { Injectable } from '@angular/core';
import { FormbirdInjectorService } from './injector/formbird-injector.service';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private ajsService: any;

  constructor(private formbirdInjectorService: FormbirdInjectorService) {
    this.ajsService = formbirdInjectorService.get('ModalService');
  }

  showDialog(message, errorType?, succFunc?, errorFunc?, discardFunc?) {
    this.ajsService.showDialog(message, errorType, succFunc, errorFunc, discardFunc);
  }

  openDialog(options){
    this.ajsService.openDialog(options);
  }
}
